import './RecentSearchResults.scss';
import { AccessTypeTag } from './AccessTypeTag';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { createAsyncSelectors } from '@lib/selectors';
import { HistoryOutlined } from '@ant-design/icons';
import { SonarText } from '@ui/text';
import { coreActions } from '@sonar-software/sonar-core';
import { Menu, Space } from 'antd';
import React, { useCallback, useMemo } from 'react';
import { useAction, useAsyncState, useOnMount } from '@hooks';
const selectors = createAsyncSelectors((state) => state.core.dataSecurity.dataAccess.search.history.get);
export const RecentSearchResults = ({ onSelect }) => {
    const { data, isRequested } = useAsyncState(selectors);
    const load = useAction(coreActions.requestGetCoreDataSecurityDataAccessSearchHistory);
    useOnMount(() => {
        load({});
    });
    const items = useMemo(() => (data !== null && data !== void 0 ? data : []).map((entry) => ({
        icon: React.createElement(HistoryOutlined, null),
        key: entry.targetId,
        label: React.createElement(Space, null,
            entry.targetDisplay,
            React.createElement(AccessTypeTag, { accessType: entry.targetType }))
    })), [data]);
    const handleSelect = useCallback((info) => {
        const entry = data === null || data === void 0 ? void 0 : data.find((item) => item.targetId === info.key);
        if (entry) {
            onSelect({
                label: entry.targetDisplay,
                type: entry.targetType.toLowerCase(),
                value: entry.targetId
            });
        }
    }, [data, onSelect]);
    if (!(data === null || data === void 0 ? void 0 : data.length) || isRequested) {
        return null;
    }
    return (React.createElement("div", { className: 'recent-search-wrapper' },
        React.createElement(SonarText, { className: 'recent-search-header', size: 20, weight: 'semibold' }, COPY_SPECIFIC.RECENT_SEARCHES),
        React.createElement(Menu, { className: 'recent-search-item-menu', items: items, mode: 'inline', onSelect: handleSelect })));
};
